import React from 'react'
import PropTypes from 'prop-types'
import FormHOC from './FormHOC'
import Button from '../elements/Button'
import TermsOfUseCheckbox from '../components/TermsOfUseCheckbox'
import TermsAndConditionsCheckbox from '../components/TermsAndConditionsCheckbox'
import { mapCisToType, SERVICE_ADSL } from '../constants'
import ComparePlans from '../components/ComparePlans/ComparePlans'
import BestPlanAvailable from '../components/BestPlanAvailable'

const options = {
    postUrl: '/api/postChangePlanBroadband',
    success: 'Success! Your ADSL plan has been updated.'
}

const state = {
    referrerCode: ''
}

class AdslPlanForm extends React.Component {
    componentDidMount () {
        this.props.setDynamicValues({
            serviceId: this.props.serviceId
        })
    }

    componentDidUpdate (prevProps) {
        if (prevProps.plan !== this.props.plan && this.props.plan.id) {
            this.props.setDynamicValues({
                planId: this.props.plan.id
            })
        }
    }

    hasErrors () {
        return Object.keys(this.props.errors).length > 0
    }

    mapExistingPlanFields () {
        return {
            title: this.props.serviceDetails.planTitle,
            data: this.props.serviceDetails.allowance,
            speed: this.props.serviceDetails.planSpeed,
            price: this.props.serviceDetails.monthlyCharge,
            features: []
        }
    }

    mapApiPlanFields () {
	    if (Object.keys(this.props.plan).length > 0) {
            return [{
                id: this.props.plan.id,
                title: this.props.plan.planTitle,
                data: this.props.plan.allowance,
                speed: this.props.plan.planSpeed,
                price: this.props.plan.price,
                features: [
                    'Home Phone Line',
                    'FREE nbn&trade; upgrade',
                    'No nbn&trade; transfer or activation fees',
                    'Note: Your current Home Phone Call Rates or any Unlimited Call Pack you may have attached to this service will remain unchanged'
                ]
            }]
        }

	    return []
    }

    render () {
        return (
            <form onSubmit={this.props.handleSubmit} onKeyDown={this.props.handleKeyDown}>
                <div className='row'>
                    <div className='col-12 col-md-8 offset-md-2 text-center'>
                        <p>Changing your ADSL2+ plan is free. Even if you are still within your contract term, you can switch to a plan of higher or lower value without being hit with a plan-change fee. You’ll also keep your current contract end-date and terms if you have one, or stay month-to-month if you don’t.</p>
                    </div>
                </div>
                {Object.keys(this.props.plan).length > 0
                    ? <React.Fragment>
                        <div className='row mb-2'>
                            <div className='col-12 col-lg-8 offset-lg-2 px-2 px-lg-4 pt-lg-4'>
                                <h2 className='text-center'>Choose your new ADSL plan below:</h2>
                                <ComparePlans
                                    handleSelect={() => {}}
                                    type={SERVICE_ADSL}
                                    plans={this.mapApiPlanFields()}
                                    existingPlan={this.mapExistingPlanFields()}
                                    selectedPlanId={this.props.values.planId}
                                />
                            </div>
                        </div>
                        <div className='row'>
                            <div className='col-12 col-md-8 offset-md-2'>
                                <TermsOfUseCheckbox
                                    errors={this.props.errors}
                                    value={this.props.values.termsOfUse}
                                    handleClick={value => this.props.setDynamicValues({ termsOfUse: value })}
                                    cisUrl='https://files.exetel.com.au/cis/180501/adsl/CIS_ADSL_Bundle_OW.pdf'
                                    termsUrl=''
                                />
                                <br />
                                <TermsAndConditionsCheckbox
                                    errors={this.props.errors}
                                    value={this.props.values.termsAndConditions}
                                    handleClick={value => this.props.setDynamicValues({ termsAndConditions: value })}
                                    type={SERVICE_ADSL}
                                />

                                {this.hasErrors() ? <div className='row-error mt-3'>Oops! Please check all fields are filled in correctly.</div> : ''}
                            </div>
                        </div>
                        <div className='row my-4'>
                            <div className='col-12 col-md-4 offset-md-2 text-center text-md-left my-2'>
                                <Button title='Submit Change' action={this.props.handleSubmit} />
                            </div>
                            <div className='col-12 col-md-4 text-center text-md-right my-2'>
                                <input placeholder='Referrer Code' name='referrerCode' value={this.props.values.referrerCode} onChange={this.props.handleInputChange} />
                            </div>
                        </div>
                      </React.Fragment>
                    : <BestPlanAvailable />}
            </form>
        )
    }
}

AdslPlanForm.propTypes = {
    serviceId: PropTypes.string.isRequired,
    serviceDetails: PropTypes.object.isRequired,
    plan: PropTypes.object.isRequired
}

export default FormHOC(AdslPlanForm, state, options)



// WEBPACK FOOTER //
// ./resources/js/forms/AdslPlanForm.js